import React from "react";
import { useStaticQuery, graphql } from "gatsby";
import Img from "gatsby-image";

const SUMO = (props) => {
  const data = useStaticQuery(graphql`
    query {
      file(relativePath: { eq: "logos/coins/sumo.png" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `);
  return (
		<Img 
			fluid={data.file.childImageSharp.fluid}
			style={props.style} 
			title={props.title} 
			alt={props.alt}
		/>
	);
};
export default SUMO;

